import { Flex } from "@/components/atoms/flex";
import { useStyles } from "@/components/atoms/interactionDetailsCard/style";
import { mergeClasses } from "@fluentui/react-components";
import { PopoverView } from "@/components/atoms/popover";
import { Info24Filled } from "@fluentui/react-icons";
import { AiIndicator } from "@/components/atoms/aiIndicator";

export interface OfferingVariableTextViewProps {
	offeringVariableText: string | undefined;
	offeringVariableTextIsAiGenerated?: boolean;
}

export const OfferingVariableTextView = (
	props: OfferingVariableTextViewProps
) => {
	const style = useStyles();

	return props.offeringVariableText ? (
		<Flex
			vAlign="center"
			column
			className={style.offeringVariableTextContainer}
		>
			<Info24Filled className={style.grayText} />
			<PopoverView
				content={
					<div
						className={mergeClasses(
							style.contentToolTip,
							style.offeringVariableTooltip
						)}
						dangerouslySetInnerHTML={{
							__html: props.offeringVariableText ?? "",
						}}
					/>
				}
				positioning="above-end"
				trigger={
					<Flex column>
						<div
							className={mergeClasses(style.grayText, style.offeringVariableText)}
							dangerouslySetInnerHTML={{
								__html: props.offeringVariableText ?? "",
							}}
						/>
						{props.offeringVariableTextIsAiGenerated && <AiIndicator mode="icon-with-text" className={mergeClasses(style.grayText, style.offeringAiIndicator)} />}
					</Flex>
				}
				openOnHover={true}
				mouseLeaveDelay={0}
				classes={{
					trigger: style.offeringVariableTooltip,
				}}
			/>
		</Flex>
	) : (
		<></>
	);
};
